import React from 'react';
import Paper from '@mui/material/Paper';

// Componentes modulares
import PropertySummaryDashboard from './PropertySummaryDashboard';

/**
 * Componente de cabeçalho consolidado para propriedades rurais,
 * exibindo informações principais da propriedade de todos os domínios.
 * Implementado com componentes modulares para melhor manutenção.
 *
 * @param {Object} propertyData - Dados da propriedade do backend
 * @param {Function} onDomainClick - Callback para quando um domínio é clicado
 * @returns {JSX.Element}
 */
const PropertyHeader = ({ propertyData, onDomainClick = null }) => {
  // Contexto de filtros removido do cabeçalho (não utilizado neste dashboard)

  // Cache local por domínio (somente para o cabeçalho) para reidratar snapshot parcial
  const [headerCache, setHeaderCache] = React.useState({});
  React.useEffect(() => {
    // limpa cache ao trocar de fileId
    setHeaderCache({});
  }, [propertyData?._metadata?.file_id, propertyData?._contextData?.filename]);

  // Removido: reidratação parcial via JsonService. O Header depende do propertyData atual e atualizações via /search.

  // Mescla cache com propertyData apenas para leitura
  const propsObj = React.useMemo(() => {
    const base = propertyData?.properties || {};
    return { ...base, ...headerCache };
  }, [propertyData, headerCache]);
  const propertyDataEnriched = React.useMemo(
    () => ({
      ...(propertyData || {}),
      properties: propsObj,
    }),
    [propertyData, propsObj],
  );

  // Função para lidar com cliques em domínios
  const handleDomainClick = (domain) => {
    if (onDomainClick && typeof onDomainClick === 'function') {
      onDomainClick(domain);
    }
  };

  return (
    <Paper
      elevation={0}
      className="mb-3 p-2 rounded-lg border border-gray-200 shadow-sm hover:shadow transition-shadow duration-200"
    >
      <PropertySummaryDashboard
        propertyData={propertyDataEnriched}
        onDomainClick={handleDomainClick}
      />
    </Paper>
  );
};

export default PropertyHeader;
